<template>
  <div>
    <div v-for="lyr in layers" :key="lyr.code" class="mb-3">
      <div class="border border-blue-lighter rounded overflow-hidden">
        <!-- Card Header -->
        <div class="bg-blue-dark text-white px-3 py-2 flex items-center justify-between">
          <span class="text-sm font-semibold">{{ $t(lyr.code) }}</span>
          <slot name="layer-action" :layer="lyr"></slot>
        </div>
        <!-- Card Body -->
        <div class="bg-white px-3 py-3">
          <div class="flex">
            <!-- Columna izquierda -->
            <div class="w-1/2 pr-2 border-r border-blue-lighter">
              <div class="mb-2">
                <span class="text-xs text-gray-500 uppercase">{{ $t('total') }}</span>
                <p class="text-lg font-semibold text-blue-dark m-0">{{ getTotal(lyr) }}</p>
              </div>
              <div>
                <span class="text-xs text-gray-500 uppercase">{{ $t('executed2') }}</span>
                <p class="text-lg font-semibold text-blue-dark m-0">{{ getExecuted(lyr) }}</p>
              </div>
            </div>
            <!-- Columna derecha -->
            <div class="w-1/2 pl-2">
              <div v-if="companyAlias !== 'x-elio'" class="mb-2">
                <span class="text-xs text-gray-500 uppercase">{{ $t('issues') }}</span>
                <p class="text-lg font-semibold text-blue-dark m-0">{{ getIncidents(lyr) }}</p>
              </div>
              <div>
                <span class="text-xs text-gray-500 uppercase">
                  {{ companyAlias === 'solaring' ? $t('pv_dashboard_execution_percent') : '%' }}
                </span>
                <p class="text-lg font-semibold text-blue-dark m-0">
                  <span v-if="useExecutedRatio">
                    {{ getExecuted(lyr) > 0 ? truncateToFixed((getExecuted(lyr) / getTotal(lyr)) * 100, 2) : 0 }}
                  </span>
                  <span v-else>
                    {{ truncateToFixed(getProgress(lyr), 2) }}
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SummaryCard",

  props: {
    layers: { type: Array, required: true },
    companyAlias: { type: String, required: true },
    getTotal: { type: Function, required: true },
    getExecuted: { type: Function, required: true },
    getIncidents: { type: Function, required: true },
    getProgress: { type: Function, required: true },
    useExecutedRatio: { type: Boolean, default: false },
  },

  methods: {
    truncateToFixed(num, decimals) {
      const factor = Math.pow(10, decimals);
      return Math.floor(num * factor) / factor;
    },
  },
};
</script>
